<template>
  <Layout>
    <div class="document-edit-wrapper">
      <div class="container-fluid">
        <div class="row align-items-start">

          <!-- =======================
               LEFT SIDE - PREVIEW
          ======================== -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="preview-card">

              <div class="preview-header">
                <h6>Aperçu du document</h6>
                <span class="doc-type">
                  {{ document.identityNature }}
                </span>
              </div>

              <div class="preview-body">

                <template v-if="document.identityNature === 'CIN_TUN'">

                    <div class="doc-block fancy">
                        <div class="doc-image-container">
                        <img v-if="document && document.rectoName" :src="'/api/image/get/' + document.rectoName" class="doc-img" />
                        <div class="doc-overlay">
                            <span class="doc-badge">RECTO</span>
                        </div>
                        </div>
                    </div>

                    <div class="doc-block fancy">
                        <div class="doc-image-container">
                        <img v-if="document && document.versoName"  :src="'/api/image/get/' + document.versoName" class="doc-img" />
                        <div class="doc-overlay">
                            <span class="doc-badge secondary">VERSO</span>
                        </div>
                        </div>
                    </div>

                </template>

                  <template v-if="document.identityNature === 'CIN_EURO'">

                    <div class="doc-block fancy">
                        <div class="doc-image-container">
                        <img v-if="document && document.versoName"  :src="'/api/image/get/' + document.versoName" class="doc-img" />
                        <div class="doc-overlay">
                            <span class="doc-badge secondary">VERSO</span>
                        </div>
                        </div>
                    </div>

                </template>


                <template v-else>
                  <div class="doc-block single">
                    <img v-if="document && document.pasName"  :src="'/api/image/get/' + document.pasName" class="doc-img" />
                  </div>
                </template>

              </div>
            </div>
          </div>

          <!-- =======================
               RIGHT SIDE - FORM
          ======================== -->
          <div class="col-lg-8 col-md-6 col-12 mt-md-0 mt-3 sticky-form">
            <form @submit.prevent="saveDocument" class="form-card">

              <!-- Header -->
              <div class="form-header">

                <div class="text-left">
                  <h5>
                    Informations du document
                    <span class="doc-number">#{{ document.documentNumber }}</span>
                  </h5>
                  <p class="subtitle">Modifier les informations extraites</p>
                </div>

                <div class="status-group">
                  <span :class="['status-pill', getOcrStatusClass(document.ocrStatus)]">
                    <span class="status-dot"></span>
                    {{ getOcrStatusLabel(document.ocrStatus) }}
                  </span>

                  <span :class="['status-pill', getOcrStatusClass(document.syncStatus)]" class="mt-md-0 mt-2 ">
                    <span class="status-dot"></span>
                    {{ getSyncStatusLabel(document.syncStatus) }}
                  </span>
                </div>
              </div>

              <!-- Body -->
              <div class="form-body">

                <div class="form-row-grid two">
                  <div class="form-field">
                    <label>Nom</label>
                    <input type="text" v-model="document.lastName" />
                  </div>

                  <div class="form-field">
                    <label>Prénom</label>
                    <input type="text" v-model="document.firstName" />
                  </div>
                </div>

                <div class="form-row-grid two">
                  <div class="form-field">
                    <label>Date de naissance</label>
                    <input type="date" v-model="document.birthDate" />
                  </div>

                  <div class="form-field" v-if="document && document.identityNature == 'PAS'">
                    <label>Date d'expiration</label>
                    <input type="date" v-model="document.expirationDate" />
                  </div>

                  <div class="form-field" v-else>
                    <label>Date de délivrance</label>
                    <input type="date" v-model="document.nationalIdIssueDate" />
                  </div>

                </div>

                <div class="form-row-grid two">
                  <div class="form-field">
                    <label>Nationalité</label>
                    <input type="text" v-model="document.nationalityCode" />
                  </div>

                  <div class="form-field" v-if="document && document.identityNature == 'PAS'">
                    <label>Sexe</label>
                    <input type="text" v-model="document.gender" />
                  </div>
                  <div class="form-field" v-else>
                    <label> Lieu de naissance</label>
                    <input type="text" v-model="document.birthPlace" />
                  </div>
                </div>

                <div class="form-row-grid two">
                  <div class="form-field">
                    <label>Numéro d'identité</label>
                    <input type="text" v-model="document.nationalIdNumber" />
                  </div>

                  <div class="form-field">
                    <label>Téléphone</label>
                    <input type="text" v-model="document.phoneNumber" />
                  </div>
                </div>

                <div class="form-row-grid">
                  <div class="form-field">
                    <label>Adresse</label>
                    <textarea rows="2" v-model="document.address"></textarea>
                  </div>
                </div>

                <div class="form-row-grid">
                  <div class="form-field">
                    <label>Profession</label>
                    <input type="text" v-model="document.profession" />
                  </div>
                </div>

              </div>

              <!-- Footer -->
              <div class="form-footer">
                <button type="button" class="btn-cancel" @click="cancelEdit">
                  Annuler
                </button>

                <button type="submit" class="btn-save">
                  Enregistrer
                </button>
              </div>

            </form>
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/LayoutScreen.vue";
import { getDocumentById, updateDocument } from '@/services/collecting-data-api.js';

export default {
  components: { Layout },

  data() {
    return {
      document: {},
      id: null,
    }
  },

  watch: {
    '$route.query.id': {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.id = newId
          this.findDocumentById()
        }
      }
    }
  },

  methods: {
    saveDocument() {
      this.updateDocumentWithExDb()
    },

    cancelEdit() {
      this.findDocumentById()
    },

    getOcrStatusLabel(code) {
      const map = {0: "Nouveau", 1: "Données extraites", 2: "Échec"}
      return map[code] ?? "-"
    },

    getSyncStatusLabel(code) {
      const map = {0: "Nouveau", 1: "Synchronisé", 2: "Échec"}
      return map[code] ?? "-"
    },

    getOcrStatusClass(code) {
      const map = {
        0: "status-new",
        1: "status-success",
        2: "status-failed"
      }
      return map[code] ?? "status-default"
    },


    //// CALL API ///

    async updateDocumentWithExDb(){
      const result = await updateDocument(this.document)
      this.document = result
    },

    async findDocumentById(){
      const result = await getDocumentById(this.id)
      this.document = result
    }
  }
}
</script>

<style scoped>


.document-edit-wrapper {
  padding: 40px 20px;
  background: #f5f7fb;
  min-height: 100vh;
}

.preview-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.05);
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.preview-header h6 {
  font-weight: 700;
  margin: 0;
}

.doc-type {
  font-size: 11px;
  font-weight: 700;
  padding: 6px 14px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
}

.doc-block.fancy {
  margin-bottom: 25px;
}

.doc-image-container {
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.doc-image-container:hover {
  transform: translateY(-6px);
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.12);
}

.doc-img {
  width: 100%;
  display: block;
  border-radius: 18px;
}

.doc-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  background: linear-gradient(
    to top,
    rgba(15, 23, 42, 0.6),
    transparent
  );
  display: flex;
  align-items: flex-end;
}

.doc-badge {
  background: #ffffff;
  color: #111827;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  padding: 6px 14px;
  border-radius: 999px;
}

.doc-badge.secondary {
  background: #111827;
  color: #ffffff;
}

.form-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 35px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.06);
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  gap: 20px;
}

@media (max-width: 768px) {
  .form-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .status-group {
    margin-top: 10px;
  }
}

.form-header h5 {
  margin: 0;
  font-weight: 700;
}

.subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 5px;
}

.form-row-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-bottom: 22px;
}

.form-row-grid.two {
  grid-template-columns: 1fr 1fr;
}

.form-field label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: #475569;
  margin-bottom: 6px;
  display: block;
}

.form-field input,
.form-field textarea {
  width: 100%;
  padding: 12px 16px;
  border-radius: 14px;
  border: 1px solid #e5eaf1;
  background: #f9fbfd;
  font-size: 14px;
  transition: all 0.2s ease;
}

.form-field input:focus,
.form-field textarea:focus {
  border-color: #111827;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.05);
  outline: none;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  margin-left: 10px;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.status-new { background: #e0f2fe; color: #0284c7; }
.status-success { background: #dcfce7; color: #059669; }
.status-failed { background: #fee2e2; color: #dc2626; }
.status-default { background: #f1f5f9; color: #64748b; }

.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
}

.btn-save {
  background: #111827;
  color: white;
  padding: 10px 24px;
  border-radius: 14px;
  border: none;
  font-weight: 600;
}

.btn-cancel {
  background: #f1f5f9;
  border: none;
  padding: 10px 20px;
  border-radius: 14px;
  font-weight: 600;
}

.btn-save:hover,
.btn-cancel:hover {
  transform: translateY(-2px);
  transition: 0.2s;
}


.sticky-form {
  position: sticky;
  top: 30px;
  align-self: flex-start;
}


.form-row-grid-rs.two {
  grid-template-columns: 1fr 1fr;
}

@media (max-width: 768px) {
  .form-row-grid-rs.two {
    grid-template-columns: 1fr;
  }
}

.doc-number {
  background: #f1f3f5;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.85em;
}

.doc-number i {
  margin-right: 4px;
  font-size: 0.85em;
}

</style>
